import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';
import { GalleryInfosState } from '../Gallery/reducer';
import { DriveListState } from './reducer';
import { DriveItemListDisplayType, DRIVE_ITEM_LIST_PAGE_SIZE } from './constants';
import { fetchDriveItem } from './actions';
import { Api } from '../../typings/api';
import Utils from '../../utils';
import DriveItem from '../DriveItem';
import { DriveItemListVariants, StyledInfiniteScrollVariants, DriveItemListContainer, LoadingStatus } from './styles';
import Masonry from '../../components/CustomMasonry';
import { AbstractDriveItemListPageParams } from '../DriveItemListPage/abstract';
const Translate = require('react-redux-i18n').Translate;

interface DriveItemListProps {
	dispatch: Dispatch<StoreState>;
	params: AbstractDriveItemListPageParams;
	galleryInfos: GalleryInfosState;
	driveList: DriveListState;
	driveItemIdsToDisplay: number[];
	isFetching: boolean;
	folderId?: number;
}

interface DriveItemListState {
	page: number;
}

class DriveItemList extends React.Component<DriveItemListProps, DriveItemListState> {

	private driveItemListElement: HTMLElement;

	constructor(props: DriveItemListProps) {
		super(props);
		this.hasMoreDriveItems = this.hasMoreDriveItems.bind(this);
		this.loadMoreDriveItems = this.loadMoreDriveItems.bind(this);
		this.state = { page: 0 };
	}

	componentWillUpdate(nextProps: DriveItemListProps, nextState: DriveItemListState) {
		const { dispatch, driveItemIdsToDisplay, folderId, driveList } = nextProps;
		const nbItemToDisplay = Math.min(nextState.page * DRIVE_ITEM_LIST_PAGE_SIZE, driveItemIdsToDisplay.length);
		const storeDriveItems = driveList.driveItems;

		if (nextProps.driveList.displayType !== this.props.driveList.displayType) {
			this.setState({ page: 0 });
		}

		if (nextProps.params !== this.props.params) {
			this.setState({ page: 0 });

			if (this.driveItemListElement) {
				this.driveItemListElement.scrollTop = 0;
			}
		}

		driveItemIdsToDisplay
			.slice(0, nbItemToDisplay)
			.forEach(driveItemId => {
				if (!storeDriveItems[driveItemId]) {
					dispatch(fetchDriveItem(driveItemId, folderId));
				}
			});
	}

	render() {
		const { galleryInfos, driveList, driveItemIdsToDisplay, isFetching } = this.props;
		const { resolutions, displayType } = driveList;
		const { driveItemsToDisplay } = this;
		const isMasonry = displayType === DriveItemListDisplayType.Masonry;
		const isEmpty = driveItemIdsToDisplay.length === 0;
		const isLoading = driveItemsToDisplay.length < this.state.page * DRIVE_ITEM_LIST_PAGE_SIZE && driveItemsToDisplay.length < driveItemIdsToDisplay.length;
		const hasMoreDriveItems = this.hasMoreDriveItems();

		const driveItemsElement = driveItemsToDisplay.map((driveItem: Api.DriveItem, index: number) => {
			return (
				<DriveItem
					key={index}
					driveItem={driveItem}
					resolutions={resolutions}
					displayType={displayType}
					galleryConfig={galleryInfos.config}
				/>);
			}
		);

		const StyledDriveItemList = DriveItemListVariants[displayType];
		const StyledInfiniteScroll = StyledInfiniteScrollVariants[displayType];
		const infiniteScrollParams = {
			loadMore: this.loadMoreDriveItems,
			hasMore: !isLoading && hasMoreDriveItems,
			useWindow: false
		};

		return (
			<DriveItemListContainer>
				<StyledDriveItemList innerRef={element => { this.driveItemListElement = element; }}>
					{(isEmpty && !isLoading && !isFetching) ? <div />
						:
						<StyledInfiniteScroll {...infiniteScrollParams} >
							{isMasonry ? <Masonry>{driveItemsElement}</Masonry> : driveItemsElement}
						</StyledInfiniteScroll>
					}
					{(isFetching || hasMoreDriveItems) && <LoadingStatus>{Utils.getSvgIcon('iconset_loading')}<Translate value="messages.loading" /></LoadingStatus>}
				</StyledDriveItemList>
			</DriveItemListContainer>
		);
	}

	private hasMoreDriveItems(): boolean {
		const { driveItemIdsToDisplay } = this.props;
		const pageCount = Math.ceil(driveItemIdsToDisplay.length / DRIVE_ITEM_LIST_PAGE_SIZE);
		return this.state.page < pageCount;
	}

	private loadMoreDriveItems(): void {
		const page = this.state.page + 1;
		this.setState({ page });
	}

	private get driveItemsToDisplay(): Api.DriveItem[] {
		const { driveItemIdsToDisplay, driveList } = this.props;
		const nbItemToDisplay = Math.min(this.state.page * DRIVE_ITEM_LIST_PAGE_SIZE, driveItemIdsToDisplay.length);
		const storeDriveItems = driveList.driveItems;

		return driveItemIdsToDisplay
			.slice(0, nbItemToDisplay)
			.map(driveItemId => storeDriveItems[driveItemId])
			.filter(driveItem => !!driveItem);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { galleryInfos, driveList } = state;
	return { galleryInfos, driveList };
};

export default connect(mapStateToProps)(DriveItemList);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/index.tsx